module.exports = __webpack_public_path__ + "img/Path.fa7ac63c.svg";